/*
 * Transmit Response Codes
 *
 * see https://dev.synchronycredit.com/transmit-mfe/docs/index.html
 */
export const responseDescriptions = {
  '0000': 'Success',
  '0001': 'System Error or Application Error',
  '0002': 'Fraud Device',
  '0003': 'Invalid Input Data',
  '0004': 'User Cancelled/Opted Out',
  '0005': 'Authentication Failure',
  '0006': 'Auth Session expired/Session expired',
  '0007': 'JWT Verification Error',
  '0011': 'One Attempt Left',
  '0012': 'Account Locked',
  '0017': 'JavaScript Error',
  '0418': 'Akamai Error'
} as const

export type TransmitResponseCode = keyof typeof responseDescriptions

/**
 * Used for the status of the types of responses received from Transmit
 */
export enum TransmitResponseCodes {
  Success = '0000',
  SystemError = '0001',
  FraudDevice = '0002',
  InvalidInputData = '0003',
  UserCancelled = '0004',
  AuthenticationFailure = '0005',
  SessionExpired = '0006',
  JWTVerificationError = '0007',
  OneAttemptLeft = '0011',
  AccountLocked = '0012',
  JavaScriptError = '0017',
  AkamaiError = '0418'
}
